import { cva } from 'class-variance-authority'

export const styles = cva(
  `
    flex
    h-10
    w-full
    bg-transparent
    px-4
    py-2
    text-base
    shadow-sm
    transition-[background-color] duration-150 ease-in-out
    rounded-lg
    border
    border-neutral-200
    text-neutral-600
    placeholder:text-neutral-400
    focus-visible:outline-none
    focus-visible:ring-1
    focus-visible:ring-ring
    disabled:cursor-not-allowed
    disabled:opacity-50
    disabled:bg-neutral-50
    md:text-sm
    peer
  `,
  {
    variants: {
      error: {
        true: `
          focus-visible:ring-0
          placeholder:text-neutral-400
          placeholder:body-sm
          border-2
          border-danger-50
        `,
      },
      hasLeftIcon: {
        true: 'pl-10',
      },
      hasRightIcon: {
        true: 'pr-8',
      },
    },
    defaultVariants: {
      error: false,
    },
  }
)

export const iconLeftStyles = cva(
  `
    pointer-events-none
  `
)

export const iconRightStyles = cva(
  `
    pointer-events-none
  `
)

export const iconRightBgStyles = cva(
  ` 
    absolute
    right-2
    top-1.5
    pointer-events-none
    duration-200
    peer-[&[data-state=open]]:rotate-[-180deg]
    text-neutral-500
  `
)

export const iconLeftBgStyles = cva(
  ` 
    absolute
    left-1
    top-1
    pointer-events-none
    text-neutral-500
  `
)
